import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { Box } from '@mui/system'
import { ExpandMore } from "@mui/icons-material";

const MarkdownBlock = ({ title, children, defaultExpanded = false }) => {
    return (
        <Box className="markdown-block">
            <Accordion elevation={0} className="p-0 my-1 " defaultExpanded={defaultExpanded} >
                <AccordionSummary className="text-muted bg-light px-3 " expandIcon={<ExpandMore fontSize="small" />} >
                    {title}
                </AccordionSummary>
                <AccordionDetails className="px-0 pt-2 m-0 pb-2">
                    {children}
                </AccordionDetails>
            </Accordion>
        </Box>
    )
}

export default MarkdownBlock